export const IMAGE_PLACEHOLDER = '/event_placeholder.png';

/**
 * Derive the S3 thumbnail URL from an original image URL:
 *   https://<bucket>/businesses/<file>.jpg
 *   → https://<bucket>/thumbnails/businesses/<file>.webp
 * Inserts the `thumbnails/` folder prefix and swaps the extension to .webp.
 *
 * Returns the placeholder for an empty input, and leaves non-absolute URLs
 * (e.g. local paths or blob: previews) untouched.
 */
export function getThumbnailUrl(originalUrl?: string): string {
  if (!originalUrl) return IMAGE_PLACEHOLDER;
  try {
    const url = new URL(originalUrl);
    url.pathname = '/thumbnails' + url.pathname.replace(/\.[^/.]+$/, '.webp');
    return url.toString();
  } catch {
    return originalUrl;
  }
}
